import { AISummary } from "@radarly/models/ai";
import { DatavizTypeAI } from "@radarly/models/dataviz";
import { AIFragment } from "@radarly/models/search";

export interface AiRepo {
  getAISummary<T extends DatavizTypeAI>(
    pid: number,
    searchFragmentAI: AIFragment & { analysis: { type: T } }
  ): Promise<AISummary<T>>;
}

export const AiRepositoryUID = Symbol("Radarly/AiRepository");
